import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=1976d8c8&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=1976d8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976d8c8",
  null
  
)

export default component.exports